'use strict';

require('../users/CompanyUserService.js');
require('./FormAppSubmitGroupService.js');
require('./FormAppSubmitGroupUserService.js');
require('../publications/PublicationTypeaheadDirective.js');
require('../users/CompanyUsersTypeahead.js');
require('./FormAppSubmitGroupObjectService.js');

function FormAppSubmitGroupDetailCtrl(
  $scope,
  FormAppGroup,
  publications,
  members,
  translations,
  $state,
  $stateParams,
  $sce,
  $window,
  $filter,
  FormAppSubmitGroupService,
  FormAppSubmitGroupUserService,
  CompanyService,
  growl
) {

  $scope.FormAppGroup = FormAppGroup;
  $scope.publications = publications;
  $scope.members = members;
  $scope.tabs = [
    {
      'title': $sce.trustAsHtml('customer-portals.documents'),
      'content': '',
      'template': 'partials/company/form-app-submit-group/detail/documents.html',
      'icon': 'file-o'
    },
    {
      'title': $sce.trustAsHtml('customer-portals.info'),
      'content': '',
      'template': 'partials/company/form-app-submit-group/detail/info.html',
      'icon': 'info-circle'
    },
    {
      'title': $sce.trustAsHtml('form-app.start-page'),
      'content': '',
      'template': 'partials/company/form-app-submit-group/detail/popup-text.html',
      'icon': 'bell'
    }
  ];

  $scope.tabs.push(
    {
      'title': $sce.trustAsHtml('customer-portals.members'),
      'content': '',
      'template': 'partials/company/form-app-submit-group/detail/members.html',
      'icon': 'users'
    }
  );

  $scope.tabs.activeTab = 0;

  $scope.save = function() {
    FormAppSubmitGroupService.update({companyId: $stateParams.companyId, groupId: $scope.FormAppGroup.id}, $scope.FormAppGroup, function() {
      angular.element('#filterRole').val('');
      growl.addSuccessMessage(translations['form-app.saved-success']);
    }, function() {
      growl.addErrorMessage(translations['form-app.saved-failure']);
    });
  };

  $scope.delete = function(id) {
    FormAppSubmitGroupService.delete({companyId: $stateParams.companyId, groupId: id}, function() {
      growl.addSuccessMessage(translations['form-app.removed-success']);
      $state.go('^.list');
    }, function() {
      growl.addErrorMessage(translations['form-app.removed-failure']);
    });
  };


  $scope.removeMember = function(userId) {
    FormAppSubmitGroupUserService.delete({companyId: $stateParams.companyId, groupId: $stateParams.groupId, userId: userId}, function() {
      $scope.members = $scope.members.filter(function(item) {
        return item.id !== userId;
      });

      growl.addSuccessMessage(translations['customer-portals.remove-member-success']);
    }, function() {
      growl.addErrorMessage(translations['customer-portals.remove-member-failure']);
    });
  };

  $scope.removePublication = function(publication, index) {
    if ($scope.FormAppGroup.publicationIds.indexOf(publication.id) > -1) {
      $scope.FormAppGroup.publicationIds.splice($scope.FormAppGroup.publicationIds.indexOf(publication.id), 1);
    }
    
    $scope.FormAppGroup.$update({companyId: $stateParams.companyId, groupId: $stateParams.groupId}, function() {
      $scope.publications.splice(index, 1);
      growl.addSuccessMessage(translations['form-app.remove-publication-success']);
    }, function() {
      growl.addErrorMessage(translations['form-app.remove-publication-failure']);
    });
  };

  $scope.searchUsers = function(filterUsers){
    $scope.members = members.filter(function(item){
      return item.name.toLowerCase().indexOf(filterUsers.toLowerCase()) > -1;
    });
  };

}

FormAppSubmitGroupDetailCtrl.resolve = {
  FormAppGroup: ['$stateParams', 'FormAppSubmitGroupService', function($stateParams, FormAppSubmitGroupService) {
    return FormAppSubmitGroupService.get({companyId: $stateParams.companyId, groupId: $stateParams.groupId}).$promise;
  }],
  members: ['$stateParams', 'FormAppSubmitGroupUserService', function($stateParams, FormAppSubmitGroupUserService) {
    return FormAppSubmitGroupUserService.query({
      companyId: $stateParams.companyId,
      groupId: $stateParams.groupId,
      limit: 200}).$promise;
  }],
  publications: ['$stateParams', 'FormAppSubmitGroupObjectService', function($stateParams, FormAppSubmitGroupObjectService){
    return FormAppSubmitGroupObjectService.query({
      companyId: $stateParams.companyId,
      groupId: $stateParams.groupId,
      all: true
    });
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'form-app.saved-success',
      'form-app.saved-failure',
      'form-app.removed-success',
      'form-app.removed-failure',
      'customer-portals.add-member-success',
      'customer-portals.add-member-failure',
      'customer-portals.remove-member-success',
      'customer-portals.remove-member-failure',
      'form-app.remove-publication-success',
      'form-app.remove-publication-failure',
      'customer-portals.documents',
      'customer-portals.members',
      'customer-portals.info',
      'customer-portals.add-publication-success',
      'customer-portals.add-publication-failure',
      'customer-portal.template.default',
      'customer-portal.template.my-page',
      'form-app.start-page'
    ]);
  }]
};
module.exports = FormAppSubmitGroupDetailCtrl;

angular.module('dokiv')
  .controller('FormAppSubmitGroupDetailCtrl', [
    '$scope',
    'FormAppGroup',
    'publications',
    'members',
    'translations',
    '$state',
    '$stateParams',
    '$sce',
    '$window',
    '$filter',
    'FormAppSubmitGroupService',
    'FormAppSubmitGroupUserService',
    'CompanyService',
    'growl',
    FormAppSubmitGroupDetailCtrl
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/form-app-submit-group/FormAppSubmitGroupDetailCtrl.js
// module id = 351
// module chunks = 0